import React, { memo, useCallback } from 'react'

import Input from '../../Input'
import { RegField } from '../types'
import KazakhstanFlagIcon from '../../../images/flag-kazakhstan.png'
import styles from './styles.module.css'
import { parseIncompletePhoneNumber, formatIncompletePhoneNumber } from 'libphonenumber-js'

interface PhoneInputProps {
  phoneNumber?: string
  error?: string | React.ReactElement
  disabled?: boolean
  onChange: (key: keyof RegField, value: RegField[typeof key]) => void
  onValidate: (...keys: ['clean_phone']) => () => void
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  phoneNumber,
  error,
  disabled,
  onChange,
  onValidate,
}) => {
  const valuePhone = phoneNumber

  const handlePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let { value } = e.target
      if (!value.startsWith('+7')) {
        value = `+7${value}`
      }

      if (value.length > 12) return
      onChange('clean_phone', parseIncompletePhoneNumber(value))
    },
    [onChange],
  )

  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    const pos = input.selectionStart ?? 0
    if (pos < 2) {
      setTimeout(() => {
        input.setSelectionRange(2, 2)
      }, 0)
    }
  }

  return (
    <>
      <Input
        type="tel"
        prefixIcon={<img src={KazakhstanFlagIcon} className={styles.phoneIcon} />}
        className={styles.phoneInput}
        disabled={disabled}
        maxLength={12}
        placeholder="+7 XXX XXX XX XX"
        value={valuePhone}
        errorMsg={error}
        onClick={handleClick}
        onBlur={onValidate('clean_phone')}
        onChange={handlePhoneChange}
      />
    </>
  )
}

export default memo(PhoneInput)
